export interface ICalculatorTheme {
  id: string;
  name: string;
  styling: {
    container: string;
    inputSection: string;
    outputSection: string;
    boxShadow: string;
    outputBoxShadow?: string;
  };
  behavior: {
    bottomMargin: boolean;
    labelClass?: string;
    showAccordion: boolean;
    includeOutputInFormData: boolean;
    showConditionalSpacing?: boolean;
  };
}

export const CALCULATOR_THEMES: Record<string, ICalculatorTheme> = {
  default: {
    id: 'default',
    name: 'Default Calculator Theme',
    styling: {
      container: 'flex w-full sm:flex-col',
      inputSection: 'p-6 sm:p-4',
      outputSection: 'p-6 sm:p-4 xs:p-3',
      boxShadow: '0px 0px 30px 0px #1369EB1A',
    },
    behavior: {
      bottomMargin: true,
      showAccordion: true,
      includeOutputInFormData: false,
      showConditionalSpacing: false,
    },
  },
  gst: {
    id: 'gst',
    name: 'GST Calculator Theme',
    styling: {
      container: 'flex items-center w-full sm:flex-col',
      inputSection: 'p-5',
      outputSection: 'p-5',
      boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.1)',
      outputBoxShadow: '0 0 30px 0 rgba(19, 105, 235, 0.10)',
    },
    behavior: {
      bottomMargin: false,
      labelClass: 'font-semibold',
      showAccordion: false,
      includeOutputInFormData: true,
      showConditionalSpacing: true,
    },
  },
};
